import { Injectable, NgZone } from '@angular/core';
import { environment } from '@environment';
import { GtmService } from '@core/services/analytics/gtm.service';

declare var google: any;
declare global {
    interface Window { fbAsyncInit: any; }
}

@Injectable({
    providedIn: 'root'
})

export class GoogleLoginService {

    auth2: any;
    device_session_id: string;
    baseUrl: string;
    isGoogleSdkLoaded: boolean = false;

    constructor(
        private zone: NgZone,
        private gtmService: GtmService
    ) {
        this.baseUrl = environment.apiUrl;
    }

    loadGoogleSDK(loginCallback, signInModalWidth) {
        const _this = this;
        return new Promise((resolve) => {
            if (_this.isGoogleSdkLoaded) {
                _this.initGoogleSDK(loginCallback, signInModalWidth);
                return resolve(true);
            }

            let s, r, t;
            r = false;
            s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = 'https://accounts.google.com/gsi/client';
            s.async = true;
            s.onload = s.onreadystatechange = function () {
                if (!r && (!this.readyState || this.readyState === 'complete')) {
                    r = true;
                    _this.isGoogleSdkLoaded = true;
                    _this.initGoogleSDK(loginCallback, signInModalWidth).then(() => {
                        resolve(true);
                    }, (err) => {
                        console.log(err);
                        resolve(false);
                    });
                }
            };

            s.onerror = () => {
                this.gtmService.logWebAnalyticsEvent("google_sign_in", "SDK loading failed");
                resolve(false); 
            }
            t = document.getElementsByTagName('script')[0];
            t.parentNode.insertBefore(s, t);
        }).catch((err) => {
            console.log(err);
        })
    }

    initGoogleSDK(loginCallback, signInModalWidth) {
        return new Promise((resolve, reject) => {
            this.zone.run(() => {
                if(!(google && google.accounts)) {
                    this.gtmService.logWebAnalyticsEvent("google_sign_in", "Google Not Initialised");
                    reject('google instance not present');
                }
                google.accounts.id.initialize({
                    client_id: environment.googleClientId,
                    callback: (response) => {
                        if(response && response.credential) {
                            loginCallback(response.credential);
                            //Reference: https://developers.google.com/identity/gsi/web/reference/js-reference#select_by
                            this.gtmService.logWebAnalyticsEvent("google_sign_in", `Login Via: ${response.select_by}`);
                        }
                    }
                });
                google.accounts.id.renderButton(
                    document.getElementById("google_signin"),
                    {   // customization attributes
                        theme: "outline",
                        size: "large", 
                        width: signInModalWidth,
                        height: "50",
                        click_listener: this.onClickHandler.bind(this)
                    }
                );
                resolve(true);
            });
        });
    }

    onClickHandler() {
        this.gtmService.logWebAnalyticsEvent("google_sign_in", "Initiated");
    }

    loadScript(src) {
        let s, r, t;
        r = false;
        s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = src;
        s.async = true;
        s.onload = s.onreadystatechange = function () {
            if (!r && (!this.readyState || this.readyState === 'complete')) {
                r = true;
            }
        };

        s.onerror = () => {
            this.gtmService.logWebAnalyticsEvent("script_failure", "Failed To Load Google One Tap SDK");
        }

        t = document.getElementsByTagName('script')[0];
        t.parentNode.insertBefore(s, t);
    }

    loadGoogleOnpTapSDK() {
        this.loadScript('https://smartlock.google.com/client');
    }
}
